/** Join classNames together while filtering out falsy values */
export const classes = (
	...classNames: Array<string | undefined | null | false>
) => {
	return classNames.filter(Boolean).join(' ');
};
